import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=e06dd80a&scoped=true&"
import script from "./Reaction.vue?vue&type=script&lang=js&"
export * from "./Reaction.vue?vue&type=script&lang=js&"
import style0 from "./Reaction.vue?vue&type=style&index=0&id=e06dd80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06dd80a",
  null
  
)

export default component.exports